import { SUPABASE_URL, SUPABASE_KEY, getDbHeaders } from "./client";

// Record a successful login. Call with the fresh JWT immediately after sign-in.
export async function dbRecordLogin(token, airline, displayName) {
  await fetch(SUPABASE_URL + "/rest/v1/rpc/record_login", {
    method: "POST",
    headers: {
      "Content-Type":  "application/json",
      "apikey":        SUPABASE_KEY,
      "Authorization": "Bearer " + token,
    },
    body: JSON.stringify({ p_airline: airline, p_display_name: displayName ?? null }),
  });
}

// Fetch the login log for the past 7 days (admin only).
export async function dbGetLoginLog() {
  const res = await fetch(SUPABASE_URL + "/rest/v1/rpc/get_login_log", {
    method: "POST",
    headers: await getDbHeaders(),
    body: JSON.stringify({}),
  });
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}
